type ButtonProps = {
  variant: 'light' | 'dark';
  text: string;
  url: string;
};

export function Button({ variant, text, url }: ButtonProps) {
  const isLight = variant === 'light';

  return (
    <a
      href={url}
      className={`inline-flex items-center gap-3 font-display font-medium text-button tracking-[var(--nav-cta-tracking)] px-[var(--nav-cta-px)] py-6 rounded-[var(--border-radius-primary)] border border-border-secondary/15 leading-none ${
        isLight
          ? 'bg-background-primary text-font-tertiary hover:[animation:shadow-pulse-light_1.5s_ease-in-out_infinite]'
          : 'bg-font-secondary text-font-primary hover:[animation:shadow-pulse-dark_1.5s_ease-in-out_infinite]'
      }`}
    >
      {text}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="/icons/arrow-right.svg" alt="" className={`size-4${isLight ? '' : ' invert'}`} />
    </a>
  );
}
